<template>
  <div
      class="flex justify-center w-full flex-wrap"
      v-if="isDev">
    <div class="w-2/3">
      <select
        v-model="selectedServer"
        class="mt-1 block w-full bg-white border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
        aria-label=".form-select-lg example"
      >
        <option
          v-for="(option, i) in serversOptions"
          :key="i"
          :value="option.value"
        >
          {{ option.label }}
        </option>
      </select>
    </div>

    <div
        v-if="isCustomServer"
        class="w-2/3 mt-2">
      <input
        v-model="customServerUrl"
        type="text"
        placeholder="Enter custom server URL"
        class="mt-1 block w-full bg-white border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
      />
    </div>

    <div class="w-2/3">
      <button
        class="inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-t-primary text-base font-medium text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-t-secondary mt-2 sm:text-sm w-full"
        @click="changeServer"
      >
        Change Server
      </button>
    </div>
  </div>
</template>

<script>
import { ENVIRONMENTS_HAVE_API_SWITCHER } from '@/enums/globals';

export default {
  name: 'EnvironmentSwitcher',
  components: {},
  computed: {
    isDev () {
      return (
        ENVIRONMENTS_HAVE_API_SWITCHER.indexOf(process.env.VUE_APP_ENV) !== -1
      );
    },
    isCustomServer () {
      return this.selectedServer === 'custom';
    },
  },
  mounted () {
    const isPredefinedServer = this.serversOptions.some(
      (server) => server.value === this.selectedServer,
    );

    if (!isPredefinedServer && this.selectedServer !== 'custom') {
      this.customServerUrl = this.selectedServer;
      this.selectedServer = 'custom';
    }
  },
  data () {
    return {
      selectedServer:
        localStorage.getItem('api-domain') || process.env.VUE_APP_API_DOMAIN,
      customServerUrl: '',

      serversOptions: [
        { label: 'development', value: 'https://dev-api.getsolo.io/' },
        {
          label: 'Staging / Pre Prod',
          value: 'https://preprod-api.foodics-online.dev/',
        },
        { label: 'production', value: 'https://api.solo.skylinedynamics.com/' },
        {
          label: 'Test Merchent 1',
          value: 'https://test-merchant-api.getsolo.io/',
        },
        {
          label: 'Test Merchent 2',
          value: 'https://test-merchant-api2.getsolo.io/',
        },
        { label: 'Test kiosk 1', value: 'https://test-kiosk-api.getsolo.io/' },
        { label: 'Test kiosk 2', value: 'https://test-kiosk-api2.getsolo.io/' },
        {
          label: 'Test Consumer 1',
          value: 'https://test-consumer-api.getsolo.io/',
        },
        {
          label: 'Test Consumer 2',
          value: 'https://test-consumer-api2.getsolo.io/',
        },
        {
          label: 'Test Marketing 1',
          value: 'https://test-marketing-api.getsolo.io/',
        },
        {
          label: 'Test Marketing 2',
          value: 'https://test-marketing-api2.getsolo.io/',
        },
        { label: 'Custom Server', value: 'custom' },
      ],
    };
  },
  methods: {
    changeServer () {
      let serverUrl = this.isCustomServer
        ? this.customServerUrl
        : this.selectedServer;

      if (serverUrl[serverUrl?.length - 1] !== '/') serverUrl += '/';

      if (this.isCustomServer && !this.customServerUrl.trim()) {
        alert('Please enter a custom server URL');
        return;
      }

      localStorage.setItem('api-domain', serverUrl);
      location.reload();
    },
  },
};
</script>
